import { render, staticRenderFns } from "./RegisterDriver.vue?vue&type=template&id=0bb95a0b&scoped=true&lang=pug&"
import script from "./RegisterDriver.vue?vue&type=script&lang=ts&"
export * from "./RegisterDriver.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterDriver.vue?vue&type=style&index=0&id=0bb95a0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb95a0b",
  null
  
)

export default component.exports